import { FeatureType } from '@numeo/types-core'
import { ChartLine } from '../../../../layouts/components/sidebar/icons'
import type { MenuItem, SidebarBadgeTone } from '../../../../layouts/components/sidebar/menuConfig'

export const MARKET_INTEL_MENU_ITEM: MenuItem = {
    id: 'market-intel',
    label: 'Market Intel',
    path: '/market-intel',
    icon: ChartLine({}),
    roles: ['dispatcher', 'updater', 'tmc'],
    feature: FeatureType.MarketIntel,
    badge: { label: 'NEW', tone: 'success' as SidebarBadgeTone },
}
